import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-2/5 flex-shrink-0">
            <div className="relative">
              <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full mb-4">
                SEO Resource Guide
              </span>
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20modern%20home%20office%20desk%20setup%20featuring%20a%2016%20inch%20silver%20MacBook%20Pro%20with%20screen%20displaying%20colorful%20product%20catalog%20grid%20interface%2C%20surrounded%20by%20a%20ceramic%20coffee%20mug%20with%20latte%20art%2C%20small%20potted%20olive%20green%20succulent%20plant%20in%20terracotta%20pot%2C%20and%20natural%20linen%20desk%20mat%2C%20warm%20afternoon%20sunlight%20streaming%20through%20sheer%20linen%20curtains%2C%20clean%20Scandinavian%20aesthetic%20with%20warm%20beige%20and%20soft%20grey%20tones%2C%20editorial%20interior%20photography%2C%20calm%20productive%20atmosphere%2C%20high%20detail%20sharp%20focus&width=800&height=600&seq=about-workspace-v2-20260712&orientation=landscape"
                  alt="Hipobuy Spreadsheet workspace overview"
                  title="Hipobuy Spreadsheet - Product Research Workspace"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              What Is <br />
              <span className="text-accent-500">Hipobuy</span> Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
              A Hipobuy Spreadsheet is an organized collection of product information, shopping resources, categories and research data designed to help users discover products efficiently. Unlike traditional browsing methods that scatter product information across dozens of tabs and sites, a well-structured hipobuy spreadsheet brings everything together in one logical, searchable format.
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8">
              Whether you are researching the latest sneaker drops, comparing fashion trends across categories like hoodies and jackets, or building a comprehensive shopping list across accessories and lifestyle items, the hipobuy spreadsheet methodology saves hours of manual searching while ensuring you never miss a great find. Thousands of savvy shoppers rely on spreadsheet-based product discovery to stay organized and informed.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <div className="bg-white rounded-xl p-4 border border-background-200">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-2">
                  <i className="ri-database-2-line"></i>
                </div>
                <p className="text-xs font-semibold text-foreground-800">Organized Database</p>
                <p className="text-xs text-foreground-500 mt-1">Structured product info in one place</p>
              </div>
              <div className="bg-white rounded-xl p-4 border border-background-200">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-2">
                  <i className="ri-filter-3-line"></i>
                </div>
                <p className="text-xs font-semibold text-foreground-800">Smart Filtering</p>
                <p className="text-xs text-foreground-500 mt-1">Quick category and price filtering</p>
              </div>
              <div className="bg-white rounded-xl p-4 border border-background-200">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-2">
                  <i className="ri-shield-check-line"></i>
                </div>
                <p className="text-xs font-semibold text-foreground-800">Verified Resources</p>
                <p className="text-xs text-foreground-500 mt-1">Curated and regularly updated links</p>
              </div>
            </div>

            <Link
              to="/article/hipobuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Read Complete Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}